import React from "react"
import BackgroundImage from "gatsby-background-image"

const HeaderEquip = ({ equip = null, image }) => {
  if (equip.purpose) {
    return (
      <section className="equip-header">
        <div className="equip-header__heading">
          <h1>{equip.title.getHTML()}</h1>
          <p className="heading__purpose">{equip.purpose}</p>
          {equip.composition &&
            <div className="composition">
              <p>{equip.composition.title}</p>
              <ol className="list">
                {equip.composition.list.map(el => <li key={el}>{el}</li>)}
              </ol>
            </div>
          }
        </div>
        <div className="image-wrapper">
          <BackgroundImage
            className="image"
            fluid={image.fluid}
            alt={image.originalName}
          />
        </div>
      </section>
    )
  } else {
    return null
  }
}


export default HeaderEquip